export default function generateRandomHash() {
  return (1e13 + Math.floor(Math.random() * 9e13) + Date.now()).toString(16);
}
